
const columns = () => {
    return [
        {
          name: "id",
          formItem: {
            type: "hidden"
          }
        },
        {
          title: "审核流程名称",
          name: "name",
          dataIndex: "name",
          searchItem: {},
          tableItem: {
            width: 200
          }
        },
        {
          title: "流程类型",
          name: "auditType",
          dataIndex: "auditType",
          dict: [
            { code: 'ApplyCommon', codeName: "公共报名" },
            { code: 'ApplyClass', codeName: "班级报名" },
            { code: '2', codeName: "考试报名" },
            { code: '3', codeName: "直播报名" },
            { code: 'ApplyActivities', codeName: "活动报名" },
            { code: '5', codeName: "投票报名" },
            { code: '6', codeName: "其他报名" }
          ],
          tableItem: {
            width: 120
          },
          searchItem: {
            type: "select"
          },
        },
        {
          title: "版本",
          name: "version",
          dataIndex: "version",
          tableItem: {
            width: 120
          }
        },
        {
          title: "流程名称",
          name: "procDefName",
          dataIndex: "procDefName",
          tableItem: {
            width: 150
          }
        },
        {
          title: "状态",
          name: "state",
          dataIndex: "state",
          tableItem: {
            width: 80
          },
          dict: [
            { code: 1, codeName: "启用" },
            { code: 0, codeName: "禁用" }
          ],
          searchItem: {
            type: "select"
          },
          formItem: {
            type: "select"
          }
        },
      ];
    }
  
  const tableApi = (api = {}) => {
    return {
      path: 'workflowAudit/listByPage',
      ...api
    }
  }
  
  const audit = (self, api) => {
    return {
      type: 'diy',
      initialValue: [],
      rowkey: 'id',
      rowName: 'name',
      columns: columns(),
      tableApi: tableApi(api)
    }
  }
  
  export default audit